import PropTypes from 'prop-types';
import { createContext, useMemo } from 'react';
import useWebhooks from '@/hooks/useWebhooks';

export const WebhooksContext = createContext({
  metrics: [],
  rawWebhooks: [],
  webhooks: [],
  webhookPlatforms: [],
  webhookPlatform: null,
  getWebhookPlatformIds: () => ({
    webhookV1Id: null,
    webhookV2Id: null,
  }),
  createWebhook: () => {},
  updateWebhook: () => {},
  deleteWebhook: () => {},
  deletingWebhookId: null,
  testingWebhookId: null,
  testWebhook: () => {},
  isFetching: false,
  isFetchingMetrics: false,
  isFetchingPlatforms: false,
  isFetchingWebhooks: false,
  refetchMetrics: () => {},
  refetchPlatforms: () => {},
  refetchWebhooks: () => {},
});

export default function WebhooksProvider({ children }) {
  const webhooks = useWebhooks();

  const value = useMemo(() => webhooks, [webhooks]);

  return <WebhooksContext.Provider value={value}>{children}</WebhooksContext.Provider>;
}

WebhooksProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
